import React from 'react';
import { useRoute } from '@react-navigation/native';

import { Screen } from '../../../design/components';
import LocationSetupDetail from './LocationSetupDetail';
import { GET_LOCATION_SETUP, MODIFY_LOCATION_SETUP } from '../../../../common/graphql/locationSetup';

const LocationSetupDetailView = () => {
	const route = useRoute();
	const { locationSetupId } = route.params || {};

	return (
		<Screen scroll={false}>
			<LocationSetupDetail
				id={locationSetupId}
				query={GET_LOCATION_SETUP}
				modifyMutation={MODIFY_LOCATION_SETUP}
			/>
		</Screen>
	);
};

export default LocationSetupDetailView;

